import { DownloadOutlined, FileImageFilled } from '@ant-design/icons'
import { useSites } from '@api/useSites'
import { GraviButton, NotificationMessage } from '@gravitate-js/excalibrr'
import api from '@utils/api'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { Button } from 'antd'
import moment from 'moment'
import React, { useRef, useState } from 'react'

export function LayoutPdf({ store, canEditStores }) {
  const hiddenFileInput = useRef(null)
  const [uploading, setIsUploading] = useState(false)
  const [deleting, setIsDeleting] = useState(false)
  const { uploadPDFMutation, removePDFMutation } = useSites()

  const handleClick = () => {
    hiddenFileInput.current.click()
  }

  const handleUpload = async (event) => {
    setIsUploading(true)
    const newFile = event.target.files[0]
    const formData = new FormData()
    formData.append('file', newFile)
    try {
      await uploadPDFMutation.mutateAsync({ store_id: store.id, file: formData })
      NotificationMessage(`File Uploaded`, `Your file has been successfully uploaded.`, false)
    } catch {
      NotificationMessage(`File Upload Failed`, `Upload Failed, please try again.`, true)
    } finally {
      setIsUploading(false)
    }
  }

  const handleRemove = async () => {
    setIsDeleting(true)
    try {
      await removePDFMutation.mutateAsync({ store_id: store.id })
      NotificationMessage(`File Removed`, `Your file has been successfully removed.`, false)
    } catch {
      NotificationMessage(`File Remove Failed`, `Remove Failed, please try again.`, true)
    } finally {
      setIsDeleting(false)
    }
  }

  if (store.layout_file) {
    const message = canEditStores
      ? 'From here you can view/download the layout PDF, update, and delete'
      : 'From here you can view/download the layout PDF'
    return (
      <div className='full-height-width p-4 pl-3 text-gray-600 store-expand-card'>
        <div>
          <b className='text-size-5'>Site Layout PDF</b>
        </div>
        <div className='vertical-flex-center pt-5' style={{ flexWrap: 'wrap' }}>
          <FileImageFilled className='text-gray-400' style={{ fontSize: '2em' }} />
          <div className='text-center flex-1 my-3'>
            <b className='text-size-5'>Layout PDF added {formatters.DATE(moment(store.layout_file_uploaded))}</b>

            <div className='pt-1 text-size-4'>{message}</div>
          </div>
          <div className='text-center flex-div justify-center items-center flex-1 my-3'>
            <div>
              {canEditStores && (
                <Button className='theme-2' onClick={handleClick} loading={uploading}>
                  Replace PDF
                </Button>
              )}
              <input type='file' onChange={handleUpload} ref={hiddenFileInput} style={{ display: 'none' }} />
            </div>
            <div>
              {canEditStores && (
                <GraviButton className='ml-3' error buttonText='Remove PDF' onClick={handleRemove} loading={deleting} />
              )}
            </div>
          </div>
          <div className='pr-3 flex-1 text-center mt-4'>
            <a className='theme-1' href={store.layout_file_url}>
              <DownloadOutlined className='pr-2' /> {`Click here to download Site ${store.store_number} Layout`}
            </a>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='full-height-width p-4 pl-3 text-gray-600 store-expand-card'>
      <div>
        <b className='text-size-5'>Site Layout PDF</b>
      </div>
      <div className='flex items-center pt-5'>
        <div className='pr-3 flex-1 text-center'>
          <span className='text-size-16'>
            <FileImageFilled className='text-gray-400' />
          </span>
        </div>
        <div className='text-center flex-1'>
          <b className='text-size-5'>No Layout PDF</b>
          {canEditStores && <div className='pt-1 text-size-4'>Upload a site layout PDF</div>}
        </div>
        {canEditStores && (
          <div className='text-center flex-1'>
            <GraviButton theme2 className='theme-2' onClick={handleClick}>
              Upload PDF
            </GraviButton>
            <input type='file' onChange={handleUpload} ref={hiddenFileInput} style={{ display: 'none' }} />
          </div>
        )}
      </div>
    </div>
  )
}
